import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const DiamondEmptyFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function DiamondEmptyFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path fillRule="evenodd" clipRule="evenodd" d="M12 .02c-1.51 0-3.03.58-4.18 1.73L1.74 7.806c-2.32 2.309-2.32 6.067 0 8.386l6.08 6.058A5.925 5.925 0 0 0 12 23.98c1.51 0 3.03-.58 4.18-1.73l6.08-6.057c2.32-2.309 2.32-6.067 0-8.386l-6.08-6.058A5.925 5.925 0 0 0 12 .02Zm0 2.999c.78 0 1.51.3 2.06.85l6.08 6.057a2.92 2.92 0 0 1 0 4.138l-6.08 6.058c-.55.55-1.29.85-2.06.85s-1.51-.3-2.06-.85l-6.08-6.058a2.92 2.92 0 0 1 0-4.138l6.08-6.058c.55-.55 1.29-.85 2.06-.85Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default DiamondEmptyFilled;